/**
 * Shared with LocalDevBanner / Layout / HomeNavMenu so spacer padding and fixed header
 * offset match on the first paint. The body class `local-dev-mode` is still applied in
 * LocalDevBanner's effect for CSS hooks, but layout math must not wait for that effect
 * or a visible gap can appear between the header and breadcrumbs until re-render.
 */
export function isLocalDevelopmentHost() {
  if (typeof window === 'undefined') return false;
  return (
    import.meta.env.DEV ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.port === '5173'
  );
}

/** True when the local dev banner is shown (same rules as LocalDevBanner). */
export function isLocalDevLayoutActive() {
  if (typeof document === 'undefined') return false;
  const isScreenBuilder = document.body.classList.contains('screenbuilder-active');
  return isLocalDevelopmentHost() && !isScreenBuilder;
}
